import { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  List,
  Modal,
  Popover,
  Row,
  Space,
  Tag,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { inboxList } from "./Data";
import "./CardInbox.css";
import ModalContent from "./ModalContent";
import { useNavigate } from "react-router-dom";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { toast } from "react-hot-toast";

function InboxCard({ todayTasks, overdueTasks }) {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [visible, setVisible] = useState(false);
  const [reSchedule, setReSchedule] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [workItemList, setWorkItemList] = useState(null);
  const [id, setId] = useState(null);
  const navigate = useNavigate();
  const showModal = (name, workItemList, id) => {
    setIsModalOpen(true);
    setModalId(name);
    setWorkItemList(workItemList);
    setId(id);
  };

  const handleCheckboxChange = (docId) => {
    setSelectedCheckboxes((prev) => {
      if (prev.includes(docId)) {
        return prev.filter((id) => id !== docId);
      } else {
        return [...prev, docId];
      }
    });
  };

  const onChange = (value, dateString) => {};

  const onOk = (value) => {};

  const formatSnoozeDate = (date, formatForNextWeek = false) => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    const dateNum = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

    if (formatForNextWeek) {
      return `${day} ${month} ${dateNum}, ${formattedHours}:${formattedMinutes}${ampm}`;
    } else {
      return `${day}, ${formattedHours}:${formattedMinutes}${ampm}`;
    }
  };

  const getTimes = () => {
    const now = new Date();

    // Later today (5 hours from now)
    const laterToday = new Date(now.getTime() + 5 * 60 * 60 * 1000);

    // Tomorrow (24 hours from now)
    const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);

    // Later this week (Upcoming Friday or Next Sunday if today is Friday)
    const laterThisWeek = new Date(now);
    if (now.getDay() < 5) {
      // If today is before Friday
      laterThisWeek.setDate(now.getDate() + (5 - now.getDay()));
    } else {
      // If today is Friday or after, set to the next Sunday
      laterThisWeek.setDate(now.getDate() + (7 - now.getDay()));
    }
    laterThisWeek.setHours(8, 0, 0);

    // Next week (7 days from now)
    const nextWeek = new Date(now);
    nextWeek.setDate(now.getDate() + (8 - now.getDay())); // Get the next Monday
    nextWeek.setHours(8, 0, 0);

    return {
      laterToday: formatSnoozeDate(laterToday),
      tomorrow: formatSnoozeDate(tomorrow),
      laterThisWeek: formatSnoozeDate(laterThisWeek, true),
      nextWeek: formatSnoozeDate(nextWeek, true),
    };
  };

  const times = getTimes();

  const runModal = (
    <div>
      <Row gutter={16} justify="center">
        <Col>SNOOZE UNTIL...</Col>
      </Row>
      <Divider style={{ margin: "5px 0" }} />
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Later today</Col>
        <Col>{times.laterToday}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Tomorrow</Col>
        <Col>{times.tomorrow}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Later this week</Col>
        <Col>{times.laterThisWeek}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Next week</Col>
        <Col>{times.nextWeek}</Col>
      </Row>
      <Divider style={{ margin: "5px 0" }} />
      <Row gutter={16} justify="center">
        <Col>
          <DatePicker
            placeholder="Pick date & time"
            showTime
            onChange={onChange}
            onOk={onOk}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
    </div>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleReScheduleChange = (reSchedule) => {
    setReSchedule(reSchedule);
  };

  const handleCheckBoxClick = (e) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
  };

  const handleItemPage = (e, id) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    navigate(`/tasks/inbox/${id}`);
  };

  const handleCompleteStatus = (e, id) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const assignedCollectionRef = collection(itemListRef, "Assigned");
    const docToUpdateRef = doc(assignedCollectionRef, id); // Replace "docId" with your specific document ID
    // Update the document
    async function updateDocument() {
      try {
        await updateDoc(docToUpdateRef, {
          // replace with the fields you want to update
          status: "completed",
        });
        toast.success("successfully updated!");
        setSelectedCheckboxes([]);
      } catch (error) {
        console.error("Error updating document:", error);
        toast.error("Error updating document!", error.message);
      }
    }
    updateDocument();
  };

  const handleSelectedCompleted = () => {
    // Prevent the item click from being triggered when clicking the checkbox
    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const assignedCollectionRef = collection(itemListRef, "Assigned");
    // Function to update a single document
    const updateDocument = async (id) => {
      const docToUpdateRef = doc(assignedCollectionRef, id); // Get the reference to the specific document
      try {
        await updateDoc(docToUpdateRef, {
          // replace with the fields you want to update
          status: "completed",
        });
        toast.success("successfully updated!");
      } catch (error) {
        console.error(`Error updating document ${id}:`, error);
        toast.error("Error updating document!");
      }
    };

    // Function to update all selectedIds
    const handleCompleteStatusForAllSelected = () => {
      for (const id of selectedCheckboxes) {
        updateDocument(id);
      }
    };

    // Execute the update for all selected IDs
    handleCompleteStatusForAllSelected();
  };

  const getInitials = (name) => {
    return name ? name.substring(0, 2) : "";
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allTasksDocIds = [...todayTasks, ...overdueTasks].map(
        (item) => item.docId
      );
      setSelectedCheckboxes(allTasksDocIds);
    } else {
      setSelectedCheckboxes([]);
    }
    setSelectAllChecked(e.target.checked);
  };

  useEffect(() => {
    const allTasksLength = todayTasks.length + overdueTasks.length;
    setSelectAllChecked(selectedCheckboxes.length === allTasksLength);
  }, [selectedCheckboxes, todayTasks, overdueTasks]);

  return (
    <div className="InboxCard">
      <>
        {overdueTasks.length > 0 && <h3>Overdue</h3>}

        {selectedCheckboxes.length > 0 && (
          <div className="checkBoxBar">
            <Row justify="space-between">
              <Col>
                <Row gutter={16}>
                  <Col>
                    <Checkbox
                      checked={selectAllChecked}
                      onChange={handleSelectAllChange}
                    >
                      {selectedCheckboxes.length} Selected
                    </Checkbox>
                  </Col>

                  <Col>
                    <Button onClick={handleSelectedCompleted}>Complete</Button>
                  </Col>

                  <Col>
                    <Popover
                      content={runModal}
                      trigger="click"
                      visible={visible}
                      onVisibleChange={handleVisibleChange}
                      placement="bottom"
                    >
                      <Button onClick={(e) => e.preventDefault()}>
                        <Space>
                          Snooze
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Popover>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Button>Done</Button>
          </div>
        )}

        {overdueTasks.length > 0 && (
          <List
            itemLayout="horizontal"
            dataSource={overdueTasks}
            renderItem={(item, index) => (
              <List.Item
                actions={[
                  hoveredIndex === item.docId ||
                  selectedCheckboxes.includes(item.docId) ? (
                    <div className="listItemAction">
                      <Popover
                        content={runModal}
                        trigger="click"
                        visible={reSchedule}
                        onVisibleChange={handleReScheduleChange}
                        placement="bottom"
                      >
                        <span key="1" onClick={handleCheckBoxClick}>
                          <i className="fa-regular fa-clock listIcons"></i>
                        </span>
                      </Popover>
                      <span
                        key="2"
                        onClick={(e) => handleItemPage(e, item.docId)}
                      >
                        <i className="fa-solid fa-arrow-up-right-from-square listIcons"></i>
                      </span>
                      <span
                        key="3"
                        onClick={(e) => handleCompleteStatus(e, item.docId)}
                      >
                        <i className="fa-solid fa-square-check listIcons"></i>
                      </span>
                    </div>
                  ) : (
                    <span>
                      <Tag
                        style={{
                          background: "#ebf4fb",
                          color: "#0079ca",
                          fontSize: "12px",
                          lineHeight: "1.6rem",
                          padding: "0px 4px",
                        }}
                      >
                        {item.workFlowRunDueDate}
                      </Tag>
                      {item.workFlowRunAssignee.map((name, index) => (
                        <Avatar key={index}>{getInitials(name)}</Avatar>
                      ))}
                    </span>
                  ),
                ]}
                onMouseEnter={() => setHoveredIndex(item.docId)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  avatar={
                    <span onClick={handleCheckBoxClick}>
                      {hoveredIndex === item.docId ||
                      selectedCheckboxes.includes(item.docId) ? (
                        <Checkbox
                          onChange={() => handleCheckboxChange(item.docId)}
                          checked={selectedCheckboxes.includes(item.docId)}
                        />
                      ) : (
                        <span>
                          <i className="fa-solid fa-table-list"></i>
                        </span>
                      )}
                    </span>
                  }
                  title={<span>{item.workFlowRunName}</span>}
                  description={item.workFlowRunName}
                  onClick={() =>
                    showModal(item.workFlowRunName, item, item.docId)
                  }
                />
              </List.Item>
            )}
          />
        )}
      </>

      {overdueTasks.length > 0 && todayTasks.length > 0 ? (
        <Divider style={{ marginTop: "50px" }} />
      ) : null}
      {todayTasks.length > 0 ? (
        <>
          <h3>Today</h3>

          <List
            itemLayout="horizontal"
            dataSource={todayTasks}
            renderItem={(item, index) => (
              <List.Item
                actions={[
                  hoveredIndex === item.docId ||
                  selectedCheckboxes.includes(item.docId) ? (
                    <div className="listItemAction">
                      <span key="1" onClick={handleCheckBoxClick}>
                        <i className="fa-regular fa-clock listIcons"></i>
                      </span>
                      <span
                        key="2"
                        onClick={(e) => handleItemPage(e, item.docId)}
                      >
                        <i className="fa-solid fa-arrow-up-right-from-square listIcons"></i>
                      </span>
                      <span
                        key="3"
                        onClick={(e) => handleCompleteStatus(e, item.docId)}
                      >
                        <i className="fa-solid fa-square-check listIcons"></i>
                      </span>
                    </div>
                  ) : (
                    <span>
                      <Tag
                        style={{
                          background: "#ebf4fb",
                          color: "#0079ca",
                          fontSize: "12px",
                          lineHeight: "1.6rem",
                          padding: "0px 4px",
                        }}
                      >
                        {item.workFlowRunDueDate}
                      </Tag>
                      {item.workFlowRunAssignee.map((name, index) => (
                        <Avatar key={index}>{getInitials(name)}</Avatar>
                      ))}
                    </span>
                  ),
                ]}
                onMouseEnter={() => setHoveredIndex(item.docId)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  avatar={
                    <span onClick={handleCheckBoxClick}>
                      {hoveredIndex === item.docId ||
                      selectedCheckboxes.includes(item.docId) ? (
                        <Checkbox
                          onChange={() => handleCheckboxChange(item.docId)}
                          checked={selectedCheckboxes.includes(item.docId)}
                        />
                      ) : (
                        <span>
                          <i className="fa-solid fa-table-list"></i>
                        </span>
                      )}
                    </span>
                  }
                  title={<span>{item.workFlowRunTitle}</span>}
                  description={item.workFlowRunName}
                  onClick={() =>
                    showModal(item.workFlowRunName, item, item.docId)
                  }
                />
              </List.Item>
            )}
          />
        </>
      ) : null}

      <ModalContent
        modalId={modalId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        workItemList={workItemList}
        id={id}
      />
    </div>
  );
}

export default InboxCard;
